import * as React from 'react'
import { clsx } from 'clsx'
import { Repository } from '@basehub/data/replicache/index'
import {
  CodeSnippet,
  CodeSnippetActions,
  CodeSnippetContainer,
} from '~/sotano-kit/primitives/code-snippet'
import { handleCopyPkCloak, pkCloak } from './pk-cloak'
import { terminalTheme } from '~/sotano-kit/primitives/bshb-theme'
import { useLantern } from '~/hooks/use-lantern'

export const ConnectRelInstructions = ({
  token,
  rel,
}: {
  token: string
  rel: NonNullable<Repository['rel']>
}) => {
  const { elementRef, maskRef } = useLantern<HTMLDivElement>({
    size: 'md',
    initial: {
      x: 620,
      y: 188,
      opacity: 1,
      backAtRest: true,
    },
  })

  let icon: React.ReactNode = <></>
  let title: React.ReactNode = <></>
  let subtitle: React.ReactNode = <></>
  switch (rel) {
    case 'playground-v0':
      icon = <V0Icon />
      title = 'Coming from v0?'
      subtitle = (
        <>
          Copy your BASEHUB_TOKEN and go back to finish the setup. Need help?{' '}
          <a
            href="https://assets.basehub.com/ed0184c4/8467e16b5deda706b1910d6cb44409a0/clipboard-20250619-123309-354.mp4"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-accent hover:underline"
          >
            Watch this video
          </a>
          .
        </>
      )
      break

    default:
      break
  }

  const Children = ({ isMask }: { isMask?: boolean }) => {
    return (
      <div
        className={clsx(
          'w-full rounded-xl border-2 bg-dark-base overflow-hidden p-4',
          isMask ? 'border-dark-accent absolute' : 'border-dark-border-solid'
        )}
        ref={isMask ? maskRef : undefined}
      >
        <p className="text-base text-dark-bright font-semibold flex items-center gap-2">
          {icon && (
            <span className="flex items-center justify-center w-6 h-6">
              {icon}
            </span>
          )}
          {title}
        </p>
        <p className="text-sm text-dark-muted mt-1">{subtitle}</p>
        <CodeSnippetContainer className="mt-5">
          <CodeSnippetActions label="BASEHUB_TOKEN" />
          <CodeSnippet
            code={pkCloak}
            copyContentOverride={token}
            onCopy={(e) => handleCopyPkCloak(e, token)}
            language="bash"
            className="p-4 overflow-x-hidden light:bg-dark-base"
            unstyled
            theme={terminalTheme}
          />
        </CodeSnippetContainer>
      </div>
    )
  }

  return (
    <div className={clsx('relative')} ref={elementRef}>
      <Children isMask />
      <Children />
    </div>
  )
}

const V0Icon = ({ className }: { className?: string }) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 40 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={clsx(className)}
    >
      <path d="M23.3919 0H32.9188C36.7819 0 39.9136 3.13165 39.9136 6.99475V16.0805H36.0006V6.99475C36.0006 6.90167 35.9969 6.80925 35.9898 6.71766L26.4628 16.079C26.4949 16.08 26.5272 16.0805 26.5595 16.0805H36.0006V19.7762H26.5595C22.6964 19.7762 19.4788 16.6139 19.4788 12.7508V3.68923H23.3919V12.7508C23.3919 12.9253 23.4054 13.0977 23.4316 13.2668L33.1682 3.6995C33.0861 3.6927 33.003 3.68923 32.9188 3.68923H23.3919V0Z"></path>
      <path d="M13.7688 19.0956L0 3.68759H5.53933L13.6231 12.7337V3.68759H17.7535V17.5746C17.7535 19.6705 15.1654 20.6584 13.7688 19.0956Z"></path>
    </svg>
  )
}
